var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWrappercoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 335,
    height: 96,
    viewBox: "0 0 335 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M63.4558 -75.2692C117.989 -69.3111 218.946 -36.7964 186.507 45.5975C145.959 148.59 14.0536 285.566 161.719 454.09",
    stroke: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M51.9148 -78.0525C106.448 -72.0944 207.405 -39.5796 174.966 42.8142C134.418 145.807 2.51256 282.783 150.178 451.307",
    stroke: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M40.3738 -80.8358C94.9069 -74.8777 195.864 -42.363 163.425 40.0309C122.877 143.023 -9.02846 280 138.637 448.524",
    stroke: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M28.8328 -83.619C83.3659 -77.6608 184.323 -45.1461 151.884 37.2477C111.336 140.24 -20.5695 277.217 127.096 445.741",
    stroke: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M17.2917 -86.4023C71.8249 -80.4441 172.782 -47.9294 140.343 34.4644C99.7946 137.457 -32.1105 274.433 115.555 442.957",
    stroke: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M5.75268 -89.1856C60.2859 -83.2275 161.243 -50.7128 128.804 31.6811C88.2555 134.673 -43.6496 271.65 104.016 440.174",
    stroke: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5.78834 -91.9689C48.7448 -86.0108 149.702 -53.4961 117.263 28.8978C76.7145 131.89 -55.1906 268.867 92.4753 437.391",
    stroke: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M-17.3313 -94.752C37.2019 -88.7939 138.159 -56.2792 105.72 26.1147C65.1716 129.107 -66.7335 266.084 80.9324 434.608",
    stroke: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M-28.8723 -97.5354C25.6609 -91.5773 126.618 -59.0625 94.1789 23.3313C53.6305 126.324 -78.2746 263.3 69.3913 431.824",
    stroke: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M-40.4114 -100.319C14.1218 -94.3606 115.078 -61.8459 82.6398 20.548C42.0915 123.54 -89.8136 260.517 57.8523 429.041",
    stroke: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M-51.9524 -103.102C2.58078 -97.1439 103.537 -64.6292 71.0988 17.7647C30.5505 120.757 -101.355 257.734 46.3113 426.258",
    stroke: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M-63.4934 -105.885C-8.96024 -99.9273 91.9965 -67.4126 59.5578 14.9813C19.0095 117.974 -112.896 254.95 34.7703 423.474",
    stroke: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M-75.0344 -108.669C-20.5013 -102.711 80.4554 -70.1958 48.0168 12.198C7.46844 115.19 -124.437 252.167 23.2292 420.691",
    stroke: "#111111"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrappercoin);
export default __webpack_public_path__ + "static/media/wrappercoin.ef0e17ae02fa4c94be529f8ccad9aea0.svg";
export { ForwardRef as ReactComponent };